module.exports = __webpack_public_path__ + "img/metal_shingles.f5e1d489.jpg";